// Shared by every domain's queries.ts: strips undefined/null/"" values so
// filter params are only sent when actually set, instead of `field=`. Also
// used to decide whether a filters object counts as "empty" (see
// hasFilters in customer.queries.ts / employee.queries.ts) — an object whose
// only keys map to "" must still count as no filters applied.
export function omitEmpty<T extends object>(obj: T): Partial<T> {
	const result: Partial<T> = {};
	(Object.keys(obj) as (keyof T)[]).forEach((key) => {
		const value = obj[key];
		if (value !== undefined && value !== null && value !== "") {
			result[key] = value;
		}
	});
	return result;
}
